import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, FilterOperatorDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

class FilterOperatorsStore {
  filterOperators: FilterOperatorDto[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const { data } = await this.api.filterOperators.getFilterOperators();

      if (data) {
        runInAction(() => {
          this.filterOperators = data?.map((type) => ({ ...type, id: type.code })) ?? [];
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      preloaderStore.preloader(false);
    }
  };
}

export const filterOperatorsStore = new FilterOperatorsStore({ api: cmApi });
